<template>
  <section class="qrCode" :style="{ backgroundImage: `url(${this.$store.state.template.profileConfig.bg})` }">
    <Header ref="header" v-show="profileConfig.showHeader" />
    <div class="qrCode-wrapper">
      <div class="qrCode-greeting">
        <label class="qrCode-greeting-label">{{ greetingLabel }}</label>
      </div>
      <div class="qrCode-print">
        <vue-qr v-if="user.key" v-bind:text="qrCodeValue" :callback="test" qid="testid"></vue-qr>
      </div>
      <div class="div-button">
        <div class="qrCode-button" @click="printQRCode" v-if="enablePrintQRCode" v-show="showPrintButton">
          <label class="qrCode-button-enabled">{{ accessConfig.logoutBtnText ? accessConfig.logoutBtnText : 'IMPRIMIR' }}</label>
        </div>
        <div class="qrCode-button" @click="logout" v-if="enablePrintQRCode">
          <label class="qrCode-button-enabled">{{ accessConfig.logoutBtnText ? accessConfig.logoutBtnText : 'VOLTAR' }}</label>
        </div>
      </div>
    </div>

    <!-- <div class="footer-wrapper"> -->
    <Footer />
    <!-- </div> -->
    <Spinner :showSpinner="!user.key" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';
import Spinner from '@/components/ui/Spinner.vue';
import VueQr from 'vue-qr';
import qz from 'qz-tray';

export default {
  name: 'QRCodeView',
  components: { Header, Footer, Spinner, VueQr },
  data() {
    return {
      user: { key: null, other: {}, opt_in: false },
      accessConfig: {
        firstPage: '',
        firstPageParams: {},
      },
      profileConfig: {},
      qrCodeValue: null,
      timerId: null,
      idleCounter: 0,
      idleTimeoutInSeconds: 90,
      enableIdleTimeout: false,
      enablePrintQRCode: false,
      showPrintButton: true,
      // Configurações específicas para Brother QL-810W
      printerConfig: {
        name: 'Brother QL-810W',
        type: 'Brother QL-810W series',
        connection: 'usb',
      },
    };
  },
  computed: {
    greetingLabel() {
      const tmpl = this.accessConfig && this.accessConfig.greetingText ? String(this.accessConfig.greetingText) : 'Olá';
      const name = this.user && this.user.name ? this.user.name : '';

      // Match variants: {userName}, {{userName}}, {username}, {{username}} (case-insensitive, allow spaces)
      const placeholderRegex = /(\{\{\s*(?:userName|username)\s*\}\}|\{\s*(?:userName|username)\s*\})/gi;

      if (placeholderRegex.test(tmpl)) {
        return tmpl.replace(placeholderRegex, name);
      }

      // Fallback: append the name if template doesn't include a placeholder
      return tmpl + (name ? ', ' + name : '');
    },
  },
  methods: {
    // Método principal simplificado para impressão
    async printQRCode() {
      try {
        console.log('Iniciando impressão via QZ Tray...');
        this.showPrintButton = false;

        // Verificar se QZ Tray está disponível
        if (!qz.websocket.isActive()) {
          await this.connectQZTray();
        }

        // Aguardar um pouco para garantir que o QR Code foi renderizado
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Buscar a impressora Brother QL-810W
        const printer = await this.findBrotherPrinter();

        if (!printer) {
          throw new Error('Impressora Brother QL-810W não encontrada');
        }

        // Obter o QR Code como base64
        const qrElement = this.$el.querySelector('.qrCode-print canvas') || this.$el.querySelector('.qrCode-print img');

        if (!qrElement) {
          throw new Error('Elemento QR Code não encontrado');
        }

        const base64Data = await this.getQRCodeAsBase64(qrElement);

        // Configurar e enviar para impressão
        await this.printWithQZTray(printer, base64Data);

        console.log('QR Code impresso com sucesso!');
        this.showPrintButton = true;
      } catch (error) {
        console.error('Erro na impressão:', error);
        this.showPrintButton = true;

        // Fallback para impressão do navegador
        //if (confirm('Erro na impressão via QZ Tray. Deseja tentar impressão padrão do navegador?')) {
        this.printQRCodeNavigator();
        //}
      }
    },

    // Imprimir usando QZ Tray - MÉTODO CORRIGIDO
    async printWithQZTray(printer, base64Data) {
      try {
        // Configuração para Brother QL-810W
        const config = qz.configs.create(printer, {
          colorType: 'blackwhite',
          orientation: 'portrait',
          copies: 1,
          jobName: 'QR Code Print',
        });

        // CORREÇÃO PRINCIPAL: Formato correto para QZ Tray
        const printData = [
          {
            type: 'pixel', // Mudança de 'image' para 'pixel'
            format: 'png',
            data: base64Data, // Apenas o base64, sem prefixo
            options: {
              x: 0.2,
              y: 0.2,
              width: 2.0,
              height: 2.0,
              scaleContent: true,
            },
          },
        ];

        // Método alternativo 1: Usar HTML
        const htmlData = [
          {
            type: 'html',
            format: 'plain',
            data: `
            <html>
              <head>
                <style>
                  body { margin: 0; padding: 20px; text-align: center; }
                  img { width: 200px; height: 200px; }
                </style>
              </head>
              <body>
                <img src="data:image/png;base64,${base64Data}" />
              </body>
            </html>
          `,
          },
        ];

        // Método alternativo 2: Usar RAW com comandos ESC/P
        const rawData = [
          {
            type: 'raw',
            format: 'plain',
            data: this.generateESCPosCommands(base64Data),
          },
        ];

        // Tentar diferentes métodos de impressão
        try {
          console.log('Tentando impressão com tipo pixel...');
          await qz.print(config, printData);
          console.log('Impressão pixel enviada com sucesso');
        } catch (pixelError) {
          console.log('Erro com pixel, tentando HTML...', pixelError);
          try {
            await qz.print(config, htmlData);
            console.log('Impressão HTML enviada com sucesso');
          } catch (htmlError) {
            console.log('Erro com HTML, tentando RAW...', htmlError);
            await qz.print(config, rawData);
            console.log('Impressão RAW enviada com sucesso');
          }
        }
      } catch (error) {
        throw new Error('Erro ao imprimir com QZ Tray: ' + error.message);
      }
    },

    // Método para gerar comandos ESC/P para Brother QL-810W
    generateESCPosCommands(base64Data) {
      // Comandos básicos ESC/P para Brother QL-810W
      const ESC = '\x1B';
      const GS = '\x1D';

      let commands = '';

      // Inicializar impressora
      commands += ESC + '@'; // Inicializar

      // Configurar para modo gráfico
      commands += GS + 'v0'; // Comando para imprimir imagem

      // Aqui você precisaria converter o base64 para dados binários
      // Para simplificar, vamos usar um método mais direto

      // Finalizar
      commands += '\n\n\n'; // Algumas linhas em branco
      commands += ESC + 'd5'; // Alimentar papel

      return commands;
    },

    // Método alternativo mais simples para Brother QL-810W
    async printSimpleBrother(printer, base64Data) {
      try {
        // Configuração simplificada
        const config = qz.configs.create(printer);

        // Dados simples
        const data = [
          {
            type: 'html',
            format: 'plain',
            data: `
            <div style="text-align: center; padding: 10px;">
              <img src="data:image/png;base64,${base64Data}" 
                  style="width: 200px; height: 200px;" />
            </div>
          `,
          },
        ];

        await qz.print(config, data);
        console.log('Impressão simples enviada com sucesso');
      } catch (error) {
        throw new Error('Erro na impressão simples: ' + error.message);
      }
    },

    // Conectar com QZ Tray - MÉTODO CORRIGIDO
    async connectQZTray() {
      try {
        console.log('Conectando com QZ Tray...');

        if (!qz.websocket.isActive()) {
          // Configurar segurança (para desenvolvimento)
          qz.security.setCertificatePromise(function (resolve, reject) {
            resolve(); // Para desenvolvimento local
          });

          // Conectar
          await qz.websocket.connect();

          // Aguardar um pouco para garantir conexão
          await new Promise((resolve) => setTimeout(resolve, 500));
        }

        if (!qz.websocket.isActive()) {
          throw new Error('Não foi possível conectar com QZ Tray. Verifique se o serviço está rodando.');
        }

        console.log('QZ Tray conectado com sucesso');
      } catch (error) {
        throw new Error('Erro ao conectar com QZ Tray: ' + error.message);
      }
    },

    // Obter QR Code como base64 - MÉTODO CORRIGIDO
    async getQRCodeAsBase64(qrElement) {
      return new Promise((resolve, reject) => {
        try {
          let canvas = qrElement;

          if (!canvas || canvas.tagName !== 'CANVAS') {
            // Se não for canvas, buscar pela imagem
            const imgElement = this.$el.querySelector('.qrCode-print img');
            if (!imgElement) {
              reject(new Error('QR Code não encontrado'));
              return;
            }

            // Criar canvas e converter imagem
            canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Tamanho adequado para impressão
            canvas.width = 300;
            canvas.height = 300;

            // Fundo branco
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            if (imgElement.complete) {
              ctx.drawImage(imgElement, 0, 0, canvas.width, canvas.height);
              const base64 = canvas.toDataURL('image/png').split(',')[1];
              resolve(base64);
            } else {
              imgElement.onload = () => {
                ctx.drawImage(imgElement, 0, 0, canvas.width, canvas.height);
                const base64 = canvas.toDataURL('image/png').split(',')[1];
                resolve(base64);
              };
              imgElement.onerror = () => reject(new Error('Erro ao carregar imagem'));
            }
          } else {
            // Canvas já existe
            const base64 = canvas.toDataURL('image/png').split(',')[1];
            resolve(base64);
          }
        } catch (error) {
          reject(new Error('Erro ao converter QR Code: ' + error.message));
        }
      });
    },

    // Buscar impressora Brother - MÉTODO MELHORADO
    async findBrotherPrinter() {
      try {
        const printers = await qz.printers.find();
        console.log('Impressoras encontradas:', printers);

        // Buscar especificamente pela Brother QL-810W
        let brotherPrinter = printers.find((printer) => printer.toLowerCase().includes('brother') && printer.toLowerCase().includes('ql-810w'));

        // Se não encontrar com o nome específico, buscar apenas Brother QL
        if (!brotherPrinter) {
          brotherPrinter = printers.find((printer) => printer.toLowerCase().includes('brother') && printer.toLowerCase().includes('ql'));
        }

        // Buscar qualquer Brother como último recurso
        if (!brotherPrinter) {
          brotherPrinter = printers.find((printer) => printer.toLowerCase().includes('brother'));
        }

        if (!brotherPrinter) {
          throw new Error('Impressora Brother não encontrada. Impressoras disponíveis: ' + printers.join(', '));
        }

        console.log('Impressora Brother encontrada:', brotherPrinter);
        return brotherPrinter;
      } catch (error) {
        throw new Error('Erro ao buscar impressoras: ' + error.message);
      }
    },

    // Método de teste simplificado
    async testQZTrayConnection() {
      try {
        if (!qz.websocket.isActive()) {
          await this.connectQZTray();
        }

        try {
          const version = await qz.api.getVersion();
          console.log('QZ Tray versão:', version);
        } catch (versionError) {
          console.log('Não foi possível obter versão, mas QZ Tray está conectado');
        }

        const printers = await qz.printers.find();
        console.log('Impressoras disponíveis:', printers);

        return true;
      } catch (error) {
        console.error('Erro no teste de conexão:', error);
        return false;
      }
    },

    // Método de fallback para impressão normal (manter como backup)
    printQRCodeNavigator() {
      console.log('Usando impressão padrão do navegador...');
      this.showPrintButton = false;

      const qrElement = this.$el.querySelector('.qrCode-print');
      const printWindow = window.open('', '_blank');

      const style = `
        <style>
          body {
            text-align: center;
            margin: 0;
            padding: 40px;
            font-family: sans-serif;
          }
          img {
            width: 300px;
            height: 300px;
          }
        </style>
      `;

      printWindow.document.write(`
        <html>
          <head>
            <title>Imprimir QR Code</title>
            ${style}
          </head>
          <body>
            ${qrElement.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
        this.showPrintButton = true;
      }, 500);
    },

    // Outros métodos existentes (manter inalterados)
    startTimer() {
      if (!this.enableIdleTimeout) return;
      this.timerId = setTimeout(() => {
        this.idleCounter++;
        if (this.idleCounter >= this.idleTimeoutInSeconds) {
          this.clearTimer();
          this.$refs.header.logout();
        } else this.startTimer();
      }, 1000);
    },

    clearTimer() {
      if (!this.enableIdleTimeout) return;
      clearTimeout(this.timerId);
      if (this.idleCounter < this.idleTimeoutInSeconds) {
        this.idleCounter = 0;
        this.startTimer();
      }
    },

    test(dataUrl, id) {
      // Callback do vue-qr
    },

    logout() {
      this.$store.commit('resetUser');
      this.$router.push({ path: '/' }).catch((err) => {
        console.error('navigation error', err);
      });
    },

    loadValues() {
      if (this.accessConfig.QRCodeMode == 'UserId') {
        this.qrCodeValue = this.user.key;
      } else if (this.accessConfig.QRCodeMode == 'Backend') {
        this.qrCodeValue = `https://backend.blitzar.com.br/api/event/${this.$store.state.eventId}/userInfo/${this.user.key}`;
      } else if (this.accessConfig.QRCodeMode == 'WEB') {
        this.qrCodeValue = window.location.host + `/#/userInfo/${this.user.key}`;
      } else if (this.accessConfig.QRCodeMode == 'userInfo') {
        this.qrCodeValue = JSON.stringify({
          user_id: this.user.key,
          name: this.$store.state.user.name,
          email: this.$store.state.user.email,
          image: this.$store.state.user.image,
        });
      } else {
        this.qrCodeValue = this.user.key;
      }
      this.user.name = this.$store.state.user.name;
    },
  },

  async beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.userProfile = this.$store.state.template.userProfile;
    this.user.key = this.$store.state.user.id;
    this.enablePrintQRCode = this.accessConfig.enablePrintQRCode ? this.accessConfig.enablePrintQRCode : false;
    this.enableIdleTimeout = this.accessConfig.enableIdleTimeout ? this.accessConfig.enableIdleTimeout : false;
    this.idleTimeoutInSeconds = this.accessConfig.idleTimeoutInSeconds ? this.accessConfig.idleTimeoutInSeconds : 90;

    if (this.enableIdleTimeout) this.startTimer();
    this.loadValues();

    // Testar conexão QZ Tray na inicialização (opcional)
    if (this.enablePrintQRCode) {
      await this.testQZTrayConnection();
    }
  },

  // Limpar conexão ao destruir componente
  beforeDestroy() {
    if (qz.websocket.isActive()) {
      qz.websocket.disconnect();
    }
    this.clearTimer();
  },
};
</script>

<style lang="scss">
body {
  overflow: hidden;
}
.qrCode-print {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.qrCode-print > * {
  width: 320px;
  height: 320px;
  border-radius: var(--input-borderRadius);
}

.qrCode-greeting {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: clamp(320px, 80%, 500px);
  padding: 5%;
}

@media (max-width: 768px) {
  .qrCode-print > * {
    height: auto;
  }
}
.qrCode-greeting {
  font-size: larger;
  color: var(--button-text);
  text-align: center;
}
.qrCode {
  position: relative;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  z-index: 1;
  overflow: hidden;
}
.qrCode-wrapper {
  // background-color: var(--main-color);

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96.8vh;
  height: calc(100dvh - 80px);
  padding-top: 0;
  @media (max-height: 460px) {
    // padding-top: 72px;
  }
  @include media('<=phone') {
    //padding-top: 72px;

    img {
      width: 80%;
    }
  }
}
.qrCode-background-img {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  // height: 100%;
  z-index: 0;
}
.qrCode-first-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55%;
  z-index: 1;
  height: 100%;
  // padding-top: 80px;
}
.qrCode-eventLogo-internal {
  img {
    // width: auto;
    max-height: 30vh;
  }
}
.qrCode-second-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 40%;
  height: 100%;
  z-index: 1;
  padding: 5%;
  // margin-top: 100px;
}
.qrCode-title {
  // align-self: center;
  margin: 2% 0 2% 0;
  // width: 118px;
  // border-bottom: 1px solid white;
  h1 {
    font-size: 32px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 0;
  }
}

.qrCode-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--button-background);
  padding: 1%;
  margin: 2% 2% 2% 2%;
  height: 40px;
  min-width: 60%;
  border: 1px solid var(--button-outline);
  border-radius: var(--input-borderRadius) !important;
  color: var(--button-text);
  font-weight: bold;
  letter-spacing: 0.1rem;
  cursor: pointer;
  outline: none;
}

.qrCode-button-enabled {
  color: var(--button-text);
  background-color: var(--button-background);
  border: 2px solid var(--button-background);
  border-bottom-left-radius: var(--card-borderRadius);
  border-bottom-right-radius: var(--card-borderRadius);
  border-radius: var(--input-borderRadius) !important;
}

.div-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20%;
}

@include media('<=tablet') {
  .qrCode-wrapper {
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    min-height: 100dvh;
  }

  .qrCode-first-container {
    width: 90%;
    min-height: 35%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .qrCode-eventLogo {
    img {
      width: auto;
      height: 50vh;
    }
  }
  .qrCode-second-container {
    justify-content: flex-start;
    padding-top: 2%;
    padding-bottom: 5%;
    width: 100%;
  }
  .user-panel {
    max-width: 76%;
  }
  .user-image-and-fields {
    flex-direction: column;
    align-items: center;
    .user-fields-wrapper {
      // align-items: center;

      .qrCode-field-input {
        // text-align: center;
        font-size: 1.3rem;
      }
    }
    #bottomOptions {
      text-align: left;
      align-self: flex-start;
    }
    .user-image-wrapper {
      width: 50%;
      // img {
      //   width: 18vw;
      //   height: 18vw;
      // }
    }
  }
  @include media('<=phone') {
    .user-panel {
      max-width: 90%;
    }
    .user-image-and-fields {
      flex-direction: column;
      align-items: center;
      // .user-image-wrapper {
      //   // width: auto;
      //   img {
      //     // width: 26vw;
      //     // height: 26vw;
      //   }
      // }
    }
  }
}

#bottomOptions {
  position: relative;
  @include media('<=phone-plus') {
    max-width: 60%;
  }
}
</style>
